(function() {
  'use strict';

  var STORAGE_COLUMNS = 'collection-grid-columns';
  var STORAGE_COLUMNS_MOBILE = 'collection-grid-columns-mobile';
  var VALID_COLUMNS = ['3', '4', '5'];
  var VALID_COLUMNS_MOBILE = ['1', '2'];

  function init() {
    console.log('[ViewControls] init called');

    var container = document.querySelector('collection-component');
    console.log('[ViewControls] container:', container);
    if (!container) return;

    var columnButtons = container.querySelectorAll('[data-grid-columns]');
    var savedColumns = localStorage.getItem(STORAGE_COLUMNS);
    console.log('[ViewControls] desktop buttons:', columnButtons.length, 'saved:', savedColumns);

    if (savedColumns && VALID_COLUMNS.indexOf(savedColumns) !== -1 && columnButtons.length) {
      container.style.setProperty('--COLUMNS', savedColumns);
      columnButtons.forEach(function(btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-grid-columns') === savedColumns);
      });
    }

    columnButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var cols = btn.getAttribute('data-grid-columns');
        console.log('[ViewControls] desktop column click:', cols);
        if (VALID_COLUMNS.indexOf(cols) === -1) return;
        container.style.setProperty('--COLUMNS', cols);
        localStorage.setItem(STORAGE_COLUMNS, cols);

        columnButtons.forEach(function(b) {
          b.classList.toggle('is-active', b === btn);
        });
      });
    });

    var mobileButtons = container.querySelectorAll('[data-grid-columns-mobile]');
    var savedMobile = localStorage.getItem(STORAGE_COLUMNS_MOBILE);
    console.log('[ViewControls] mobile buttons:', mobileButtons.length, 'saved:', savedMobile);

    if (savedMobile && VALID_COLUMNS_MOBILE.indexOf(savedMobile) !== -1 && mobileButtons.length) {
      container.style.setProperty('--COLUMNS-MOBILE', savedMobile);
      container.style.setProperty('--COLUMNS-SMALL', savedMobile);
      mobileButtons.forEach(function(btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-grid-columns-mobile') === savedMobile);
      });
    }

    mobileButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var cols = btn.getAttribute('data-grid-columns-mobile');
        console.log('[ViewControls] mobile column click:', cols);
        if (VALID_COLUMNS_MOBILE.indexOf(cols) === -1) return;
        container.style.setProperty('--COLUMNS-MOBILE', cols);
        container.style.setProperty('--COLUMNS-SMALL', cols);
        localStorage.setItem(STORAGE_COLUMNS_MOBILE, cols);

        mobileButtons.forEach(function(b) {
          b.classList.toggle('is-active', b === btn);
        });
      });
    });

    var mobileQuery = window.matchMedia('(max-width: 749px)');

    // Each card stores its own sock/model slide index because the gallery
    // order varies per product.
    function scrollSlidersToView(showSock) {
      var sliders = container.querySelectorAll('[data-hover-slider]');
      sliders.forEach(function(slider) {
        var attr = showSock
          ? slider.getAttribute('data-sock-index')
          : slider.getAttribute('data-model-index');
        var idx = parseInt(attr, 10);
        if (isNaN(idx)) idx = showSock ? 1 : 0;
        var slideWidth = slider.clientWidth;
        if (slideWidth > 0) {
          slider.scrollTo({ left: slideWidth * idx, behavior: 'instant' });
        }
      });
    }

    var viewToggle = container.querySelector('[data-view-toggle]');
    if (viewToggle) {
      // Image convention: media[0] = model, media[1] = sock.
      // checked => MODEL view (featured media[0]).
      // unchecked => SOCK view (show the media[1] overlay via collection--flat-view).
      //
      // The view ALWAYS starts on MODEL and is intentionally NOT persisted across
      // page loads. This keeps the default deterministic for the SOCK/MODEL A/B
      // test (Control = MODEL for everyone; the test flips to SOCK for the variant)
      // and avoids a stored preference "sticking" between sessions. The toggle
      // still works within the current page.
      viewToggle.checked = true;
      container.classList.remove('collection--flat-view');

      viewToggle.addEventListener('change', function() {
        var showSock = !viewToggle.checked;
        container.classList.toggle('collection--flat-view', showSock);

        if (mobileQuery.matches) {
          scrollSlidersToView(showSock);
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
